<script>
  import { onMount } from 'svelte';
  import { __, } from '~/data-utils';
  import { lang } from 'apps/imd/stores';
  import OpeningHoursFormatter from 'components/hours/formatter';

  let now = new Date();
  let day = 0;
  let formatter;
  let time = '';
  let date = '';

  // Update formatter w/ lang changes
  $: if ($lang) {
    formatter = new OpeningHoursFormatter($lang, __);
  }

  // Update time & date when now or formatter changes
  $: if (formatter) {
    const [hour, min] = [now.getHours(), now.getMinutes()];
    time = hour + ':' + min.toString().padStart(2, '0');
    if (now.getDay() > day) {
      date = formatter.formatDate(now, true);
    }
  }

  // Start clock
  onMount(() => {
    const interval = setInterval(() => {
      now = new Date();
    }, 5000); // Probably okay to keep lower frequency

    return () => {
      clearInterval(interval);
    };
  });

</script>

<div class="today">
  <p class="today__time">{time}</p>
  <p class="today__date">{date}</p>
</div>
